
export enum GiftCardType {
  Remaining = 1,
  Sold = 2
}
